import newsList from './news-list/news-list.vue';
import newsTags from './news-tags/news-tags.vue';
import { mapState, mapActions } from 'vuex';
import VuePagination from '@ui-common/vue-pagination';
import VueFeedback from '@ui-common/vue-feedback';
const SEPARATOR = '/';
const ALL_THEME_TAG_URL = 'osszes';

export default {
	props: {
		pageSize: {
			type: Number,
			default: 10
		},
		niceUrlFull: {
			type: String,
			required: true
		},
		niceUrl: {
			type: String,
			required: true
		},
		segment: {
			type: String,
			required: true
		}
	},
	components: {
		newsList,
		newsTags,
		VuePagination,
		VueFeedback
	},
	computed: {
		...mapState('newsModule', ['technicalError', 'loading', 'newsList', 'tags', 'allThemeTag', 'visibleHits', 'allNewsCount', 'selectedTag']),
		currentPage: {
			get() {
				return this.$store.state.newsModule.currentPage;
			},
			set(value) {
				this.$store.dispatch('newsModule/setCurrentPage', value);
			}
		},
		isJsonNewsSource() {
			return this.segment === 'HPR';
		}
	},
	methods: {
		...mapActions('newsModule', ['getNews', 'getTags', 'selectTag', 'pushTag', 'getJsonData', 'getJsonTags', 'getJsonNews']),
		getParamsFromPath(path) {
			let splitted = path.split(SEPARATOR);
			let indexOfNews = splitted.indexOf(this.niceUrl);
			let tagUrl = splitted[indexOfNews + 1];
			let tag = tagUrl ? this.findTag(tagUrl) : {};
			return {
				tag: !tagUrl || tagUrl == ALL_THEME_TAG_URL ? null : tag.tag,
				url: !tagUrl || tagUrl == ALL_THEME_TAG_URL ? null : tag.url,
				// oldalszámból start
				start: (splitted[indexOfNews + 2] - 1) * this.pageSize || '0',
				rows: this.pageSize
			};
		},
		findTag(tagUrl) {
			let resultTag = this.allThemeTag;
			if (this.tags && this.tags.length) {
				resultTag =
					this.tags.find((tag) => {
						return tag.url == tagUrl;
					}) || resultTag;
			}
			return resultTag;
		},
		gotoPage(page) {
			this.select(this.selectedTag, page);
		},
		select(tag, page = 1) {
			const chosenTag = tag.tag ? tag : this.tags.find((currentTag) => currentTag.tag == tag);
			this.selectTag(chosenTag);
			this.currentPage = page;
			let params = {
				tag: chosenTag.url == ALL_THEME_TAG_URL ? null : chosenTag.tag,
				start: (page - 1) * this.pageSize,
				rows: this.pageSize,
				segment: this.segment
			};
			const promise = this.isJsonNewsSource ? this.getJsonNews(params) : this.getNews(params);
			promise.then(() => {
				let url = this.createUrl(chosenTag);
				window.history.pushState({}, '', url);
				this.$nextTick(() => {
					this.$scrollTo(this.$el);
				});
			});
		},
		createUrl(tag) {
			return window.location.origin + this.niceUrlFull + SEPARATOR + tag.url + SEPARATOR + this.currentPage;
		}
	},
	mounted() {
		window.onpopstate = () => {
			let params = this.getParamsFromPath(window.location.pathname);
			params.segment = this.segment;
			let tag = this.findTag(params.tag);
			if (this.isJsonNewsSource) {
				this.getJsonNews(params);
			} else {
				this.getNews(params);
			}
			const pageNo = parseInt(params.start, 10) / this.pageSize + 1;
			this.currentPage = pageNo;
			this.selectTag(tag);
		};
	},
	created() {
		if (this.isJsonNewsSource) {
			this.getJsonData().then(() => {
				this.getJsonTags().then(() => {
					this.pushTag(this.allThemeTag);
					let params = this.getParamsFromPath(window.location.pathname);
					let tag = this.findTag(params.url);
					this.getJsonNews(params);
					const pageNo = parseInt(params.start, 10) / this.pageSize + 1;
					this.currentPage = pageNo;
					this.selectTag(tag);
				});
			});
		} else {
			this.getTags({ segment: this.segment }).then(() => {
				this.pushTag(this.allThemeTag);
				let params = this.getParamsFromPath(window.location.pathname);
				params.segment = this.segment;
				let tag = this.findTag(params.url);
				this.getNews(params);
				const pageNo = parseInt(params.start, 10) / this.pageSize + 1;
				this.currentPage = pageNo;
				this.selectTag(tag);
			});
		}
	}
};
